// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__4xH6v","fullView":"styles_fullView__1A0N6"};